"use client";

import React, { useRef, useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const Category = ({ categories = [], handleCategory, activeCategory }) => {
  const scrollRef = useRef(null);

  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  // 🔍 Check scroll position
  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;

    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(
      el.scrollLeft + el.clientWidth < el.scrollWidth - 5
    );
  };


  const scrollLeft = () => {
    scrollRef.current?.scrollBy({
      left: -200,
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    scrollRef.current?.scrollBy({
      left: 200,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    checkScroll();
    window.addEventListener("resize", checkScroll);
    return () => window.removeEventListener("resize", checkScroll);
  }, [categories]);

  if (!Array.isArray(categories)) return null;

  return (
    <div>
      <div className="max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)]">
        <div className="relative flex items-center gap-2">
          <button
            onClick={scrollLeft}
            disabled={!canScrollLeft}
            className={`p-2 rounded-full border transition flex items-center justify-center
              ${canScrollLeft
                ? "bg-white hover:bg-gray-100"
                : "bg-gray-100 opacity-40 cursor-not-allowed"
              }`}
          >
            <ChevronLeft className="w-5 h-5" />
          </button>

          <div
            ref={scrollRef}
            onScroll={checkScroll}
            className="
          flex gap-2 md:gap-4
          overflow-x-auto
          whitespace-nowrap
          scrollbar-hide
          flex-1
          py-2
        "
          >
            {categories.map((cat, index) => {
              if (!cat || !cat.titel) return null;

              const isActive = activeCategory === cat.titel;

              return (
                <button
                  key={cat.id ?? index}
                  onClick={() => handleCategory(cat)}
                  style={{ fontFamily: "saans-regular, Arial, sans-serif" }}
                  className={`
                flex-shrink-0
                capitalize
                text-[14px] sm:text-[15px] md:text-[16px]
                font-medium sm:font-bold
                px-4 py-2
                border border-[#00000033]
                transition-all
                ${isActive
                      ? "bg-[#FFA201] text-black"
                      : "text-black hover:bg-[#FFA201]"
                    }
              `}
                >
                  {cat.titel}
                </button>
              );
            })}
          </div>
          <button
            onClick={scrollRight}
            disabled={!canScrollRight}
            className={`p-2 rounded-full border transition flex items-center justify-center
    ${canScrollRight
                ? "bg-white hover:bg-gray-100"
                : "bg-gray-100 opacity-40 cursor-not-allowed"
              }`}
          >
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Category;